import type { DynamicFilterItem } from "@/store/news-feed/filters/dynamic-filters.slice";
import FilterComponentItem from "../FilterComponentItem";
import PaginatedExpandableList from "../key-messages-filter/PaginatedExpandableList";

interface PublisherMediaListGroupRowProps {
  group: DynamicFilterItem;
  total: number | undefined;
  isGroupSelected: boolean;
  isExpanded: boolean;
  memberLists: DynamicFilterItem[];
  selectedListIds: Set<string>;
  listTotalsById: Map<string, number>;
  onToggleGroupSelection: (groupId: string) => void;
  onToggleGroupExpansion: (groupId: string) => void;
  onToggleListSelection: (listId: string) => void;
}

const PublisherMediaListGroupRow = ({
  group,
  total,
  isGroupSelected,
  isExpanded,
  memberLists,
  selectedListIds,
  listTotalsById,
  onToggleGroupSelection,
  onToggleGroupExpansion,
  onToggleListSelection,
}: PublisherMediaListGroupRowProps) => {
  const hasLists = memberLists.length > 0;

  return (
    <div>
      <FilterComponentItem
        className="px-0"
        title={group.label}
        count={total}
        toggleFilter={() => onToggleGroupSelection(group.id)}
        tabIndex={0}
        selected={isGroupSelected}
        expand={hasLists}
        isExpanded={isExpanded}
        handleExpandClick={() => onToggleGroupExpansion(group.id)}
      />
      {hasLists && (
        <PaginatedExpandableList
          isOpen={isExpanded}
          className="pl-6"
          groupId={group.id}
          items={memberLists}
        >
          {memberLists.map((list) => (
            <FilterComponentItem
              key={`list-${list.id}`}
              title={list.label}
              count={listTotalsById.get(list.id)}
              toggleFilter={() => onToggleListSelection(list.id)}
              tabIndex={0}
              selected={selectedListIds.has(list.id)}
              className="px-0"
            />
          ))}
        </PaginatedExpandableList>
      )}
    </div>
  );
};

PublisherMediaListGroupRow.displayName = "PublisherMediaListGroupRow";

export default PublisherMediaListGroupRow;
